var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysFavoriteFilled = function SvgSysFavoriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a.706.706 0 0 1 .637.413l1.778 3.771 3.978.6a.718.718 0 0 1 .572.5.765.765 0 0 1-.18.76L11.91 9.989l.679 4.144a.757.757 0 0 1-.282.725.683.683 0 0 1-.746.057L8 12.958l-3.558 1.957a.683.683 0 0 1-.746-.056.758.758 0 0 1-.282-.724l.68-4.146-2.88-2.939a.765.765 0 0 1-.18-.761.718.718 0 0 1 .573-.5l3.978-.6 1.78-3.776A.706.706 0 0 1 8 1Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysFavoriteFilled;